import {
  Container,
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Pagination,
  Paper,
  InputAdornment,
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Divider,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EditIcon from "@mui/icons-material/Edit";
import React, { useState, useEffect, useMemo } from "react";
import { FaEye } from "react-icons/fa";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FilterListIcon from "@mui/icons-material/FilterList";
import SaveIcon from "@mui/icons-material/Save";
import EmailIcon from "@mui/icons-material/Email";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const STATUS_CONFIG = {
  "Super Hot": { label: "Interested", bg: "#fce4ec", color: "#c62828" },
  "Very Hot":  { label: "Very Hot",   bg: "#fce4ec", color: "#c62828" },
  "Hot":       { label: "Hot",        bg: "#fff3e0", color: "#e65100" },
  "Cold":      { label: "Cold",       bg: "#f3e5f5", color: "#6a1b9a" },
  "Very Cold": { label: "Very Cold",  bg: "#f3e5f5", color: "#6a1b9a" },
  "Lost":      { label: "Lost",       bg: "#fafafa", color: "#757575" },
  "Converted": { label: "Converted",  bg: "#e8f5e9", color: "#2e7d32" },
};

function EnquiryFollow() {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [followUpType, setFollowUpType] = useState("");
  const [showDateFields, setShowDateFields] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [enquiryData, setEnquiryData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
  const [assignedToOptions, setAssignedToOptions] = useState([]);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMaster, setIsMaster] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editForm, setEditForm] = useState({
    nextFollowUpDate: "",
    trackedThrough: "",
    status: "",
    assignedTo: "",
    remarks: "",
  });
  const [editFormErrors, setEditFormErrors] = useState({});

  const statusOptions = ["Super Hot", "Very Hot", "Hot", "Cold", "Very Cold", "Lost", "Converted"];

  // Build userId → employeeName lookup
  const assignedToMap = useMemo(() => {
    const map = {};
    assignedToOptions.forEach((opt) => { map[opt.userId] = opt.employeeName; });
    return map;
  }, [assignedToOptions]);

  useEffect(() => {
    if (followUpType) handleSearch();
  }, [selectedBranchId]);

  useEffect(() => {
    const isMasterUser = sessionStorage.getItem("is_Master") === "true";
    setIsMaster(isMasterUser);
    if (isMasterUser) fetchBranches();
    else setSelectedBranchId(sessionStorage.getItem("branchId"));
    fetchAssignedToOptions();
  }, []);

  useEffect(() => {
    if (showDateFields) {
      const today = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(today.getMonth() - 1);
      const fmt = (d) => d.toISOString().split("T")[0];
      setToDate(fmt(today));
      setFromDate(fmt(oneMonthAgo));
    }
  }, [showDateFields]);

  useEffect(() => {
    if (followUpType && followUpType !== "SelectDate") handleSearch();
  }, [followUpType]);

  useEffect(() => {
    const lower = searchTerm.toLowerCase();
    const filtered = enquiryData.filter((e) =>
      [e.parent_GaurdianName, e.mobile, e.enquiryCode]
        .map((v) => (v || "").toLowerCase())
        .some((f) => f.includes(lower))
    );
    setFilteredData(filtered);
    setPage(1);
  }, [searchTerm, enquiryData]);

 const formatDateForFetch = (ds) => {
  if (!ds) return "";
  const [y, m, d] = ds.split("-");
  return `${d}/${m}/${y}`;   // ✅ dd/mm/yyyy
};
  const formatDateForInsert = (ds) => {
    if (!ds) return "";
    const [y, m, d] = ds.split("-");
    return `${d}/${m}/${y}`;
  };

  const handleFollowUpTypeChange = (event) => {
    const v = event.target.value;
    setFollowUpType(v);
    setShowDateFields(v === "SelectDate");
    setEnquiryData([]);
    setFilteredData([]);
    setError(null);
    setFormErrors({});
    setSelectAll(false);
    setIsSearchPerformed(false);
    setLoading(false);
  };

  const fetchBranches = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/Branch/GetBranch`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      });
      if (res.ok) {
        const data = await res.json();
        setBranches(data);
        if (data?.length > 0) setSelectedBranchId(data[0].branchId);
      }
    } catch (e) { console.error(e); }
  };

  const fetchAssignedToOptions = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/Enquiry/ddlTeacher`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      });
      if (!res.ok) throw new Error(`${res.status}`);
      const data = await res.json();
setAssignedToOptions(Array.isArray(data) ? data : []);
    } catch (e) { console.error(e); }
  };

  const handleSearch = async () => {
    setIsSearchPerformed(true);
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
      let body = {};
      if (followUpType === "SelectDate") {
        if (!fromDate || !toDate) {
          setError("Please select both From Date and To Date.");
          setEnquiryData([]);
          setLoading(false);
          return;
        }
        body = { ddlOption: followUpType, fromDate: formatDateForFetch(fromDate), toDate: formatDateForFetch(toDate), branchId };
      } else if (["AllCurrentDate", "PendingFollowUp"].includes(followUpType)) {
        const today = new Date().toISOString().slice(0, 10);
        body = { ddlOption: followUpType, fromDate: formatDateForFetch(today), toDate: formatDateForFetch(today), branchId };
      } else {
        body = { ddlOption: followUpType, fromDate: "", toDate: "", branchId };
      }

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/EnquiryFollowUp/FetchFollowUpList`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        if (res.status === 404) { setEnquiryData([]); setError("No record found."); setLoading(false); return; }
        throw new Error(`${res.status}`);
      }

      const raw = await res.json();
      const data = Array.isArray(raw.data) ? raw.data : raw;
      if (data?.length > 0) {
        setEnquiryData(data.map((item) => ({ ...item, isChecked: false })));
        setError(null);
      } else {
        setEnquiryData([]);
        setError("No data available");
      }
    } catch (e) {
      console.error(e);
      setError("Error fetching data. Please try again later.");
      setEnquiryData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFollowUpType(""); setShowDateFields(false); setFromDate(""); setToDate("");
    setEnquiryData([]); setFilteredData([]); setError(null); setFormErrors({});
    setSelectAll(false); setSearchTerm(""); setPage(1); setIsSearchPerformed(false); setLoading(false);
  };

  const handleCheckboxChange = (event, index) => {
    const newData = [...enquiryData];
    newData[index].isChecked = event.target.checked;
    setEnquiryData(newData);
    setSelectAll(newData.every((i) => i.isChecked));
  };

  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setSelectAll(checked);
    setEnquiryData(enquiryData.map((i) => ({ ...i, isChecked: checked })));
  };

  // ─── Edit Modal ───────────────────────────────────────────────────────────
  const handleEditClick = (globalIndex) => {
    const e = enquiryData[globalIndex];
    setEditingIndex(globalIndex);
    setEditForm({
      nextFollowUpDate: e.nextFollowUpDate || "",
      trackedThrough: e.trackedThrough || "",
      status: e.status || "",
      // Pre-fill assignedTo from the row or resolve from map
      assignedTo: e.assignedTo || assignedToMap[e.assignedUserId] || "",
      remarks: e.remarks || "",
    });
    setEditFormErrors({});
    setEditModalOpen(true);
  };

  const handleEditFormChange = (field, value) => {
    setEditForm((p) => ({ ...p, [field]: value }));
    setEditFormErrors((p) => ({ ...p, [field]: "" }));
  };

  const validateEditForm = () => {
    const errs = {};
    if (!editForm.trackedThrough) errs.trackedThrough = "Follow Up method is required";
    if (!editForm.status) errs.status = "Status is required";
    if (!editForm.assignedTo) errs.assignedTo = "Assigned To is required";
    if (!editForm.nextFollowUpDate) errs.nextFollowUpDate = "Follow Up Date is required";
    setEditFormErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleEditSave = () => {
    if (!validateEditForm()) return;
    const newData = [...enquiryData];
    newData[editingIndex] = {
      ...newData[editingIndex],
      nextFollowUpDate: editForm.nextFollowUpDate,
      trackedThrough: editForm.trackedThrough,
      status: editForm.status,
      assignedTo: editForm.assignedTo,
      remarks: editForm.remarks,
      isChecked: true,
    };
    setEnquiryData(newData);
    setSelectAll(newData.every((i) => i.isChecked));
    setEditModalOpen(false);
    setEditingIndex(null);
  };

  const validateForm = () => {
    const errs = {};
    enquiryData.forEach((e, i) => {
      if (e.isChecked) {
        if (!e.trackedThrough) errs[`trackedThrough-${i}`] = "Required";
        if (!e.status) errs[`status-${i}`] = "Required";
        if (!e.assignedTo) errs[`assignedTo-${i}`] = "Required";
        if (!e.nextFollowUpDate) errs[`nextFollowUpDate-${i}`] = "Required";
      }
    });
    setFormErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      const token = sessionStorage.getItem("token");
      const userId = parseInt(sessionStorage.getItem("userId")) || 0;
      const clientName = sessionStorage.getItem("clientName") || "";
      const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
      const checked = enquiryData.filter((e) => e.isChecked);

      const payload = checked.map((e) => ({
        enquiryDate: e.enquiryDate || "",
        followUpDate: formatDateForInsert(e.nextFollowUpDate) || "",
        enquieryCode: String(e.enquiryCode || ""),
        parent_GurdianName: e.parent_GaurdianName || "",
        branchId,
        mobileNo: e.mobile || "",
        remark: e.remarks || "",
        followUpType: e.trackedThrough || "",
        status: e.status || "",
        enquiryId: Number(e.enquiryId) || 0,
        assignId: assignedToOptions.find((o) => o.employeeName === e.assignedTo)?.userId || 0,
      }));

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/EnquiryFollowUp/InsertFollowUp`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const txt = await res.text();
        setSnackbarMessage(`Error saving: ${res.status} - ${txt}`);
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return;
      }

      const notifUrl = "https://wsmsv1.aidigitalsec.com/api/Notifications/PostAssignmentNotification";
      for (const e of checked) {
        await fetch(notifUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: token },
          body: JSON.stringify({ userId, message: `${clientName} created follow-up for ${e.parent_GaurdianName}'s enquiry ${e.enquiryCode}`, name: clientName }),
        }).catch(console.error);
      }

      setSnackbarMessage("Follow-up data saved successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      handleSearch();
    } catch (e) {
      console.error(e);
      setSnackbarMessage("Error saving follow-up data. Please try again later.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleEyeClick = async (enquiryId) => {
    try {
      const token = sessionStorage.getItem("token");
      const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/EnquiryFollowUp/FollowUpRecordById`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({ enquiryId, branchId }),
      });
      if (!res.ok) throw new Error(`${res.status}`);
      setSelectedEnquiry(await res.json());
      setModalOpen(true);
    } catch (e) { console.error(e); }
  };

  const paginatedData = filteredData.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  // Info sections
  const infoSections = [
    {
      icon: <FilterListIcon sx={{ color: "#1976d2", fontSize: 22 }} />,
      title: "Follow Up Type Filter",
      color: "#e3f2fd",
      borderColor: "#1976d2",
      items: [
        { label: "Selected Date Wise", desc: "Filter enquiries by a custom date range (From Date – To Date)." },
        { label: "Current Date", desc: "Shows all follow-ups scheduled for today." },
        { label: "Pending", desc: "Lists all overdue or unactioned follow-ups past their due date." },
      ],
    },
    {
      icon: <AssignmentIcon sx={{ color: "#7b1fa2", fontSize: 22 }} />,
      title: "Table Columns",
      color: "#f3e5f5",
      borderColor: "#7b1fa2",
      items: [
        { label: "Enquiry Code", desc: "Unique identifier for the enquiry record." },
        { label: "Parent Name", desc: "Name of the parent or guardian associated with the enquiry." },
        { label: "Mobile", desc: "Contact number of the parent/guardian." },
        { label: "Enquiry Date", desc: "The date the original enquiry was created." },
        { label: "Last Follow-Up", desc: "The most recent follow-up date on record." },
        { label: "Assigned To", desc: "Staff member responsible — resolved automatically from the backend." },
        { label: "Remarks", desc: "Additional notes or comments from the original enquiry." },
      ],
    },
    {
      icon: <PhoneIcon sx={{ color: "#e65100", fontSize: 22 }} />,
      title: "Follow Up Methods",
      color: "#fff3e0",
      borderColor: "#e65100",
      items: [
        { label: "Phone", desc: "Follow-up was conducted via a phone call." },
        { label: "Email", desc: "Follow-up was conducted via email communication." },
      ],
    },
    {
      icon: <CheckCircleOutlineIcon sx={{ color: "#2e7d32", fontSize: 22 }} />,
      title: "Status Levels",
      color: "#e8f5e9",
      borderColor: "#2e7d32",
      items: [
        { label: "Interested (Super Hot)", desc: "Highly interested lead, top priority for conversion." },
        { label: "Very Hot", desc: "Very likely to convert, requires immediate follow-up." },
        { label: "Hot", desc: "Interested but needs a little more nurturing." },
        { label: "Cold", desc: "Low interest; follow-up at a lower frequency." },
        { label: "Very Cold", desc: "Minimal interest; may require re-engagement strategy." },
        { label: "Lost", desc: "Enquiry has been lost or the lead has dropped out." },
        { label: "Converted", desc: "Enquiry successfully converted into an admission." },
      ],
    },
    {
      icon: <SaveIcon sx={{ color: "#0277bd", fontSize: 22 }} />,
      title: "Actions",
      color: "#e1f5fe",
      borderColor: "#0277bd",
      items: [
        { label: "Checkbox Selection", desc: "Select individual rows or use 'Select All' to bulk-process follow-ups." },
        { label: "Eye (View) Icon", desc: "Click to view the complete follow-up history for a specific enquiry." },
        { label: "Edit Icon", desc: "Opens the edit modal. Assigned To is pre-filled from the backend. Editing auto-checks the row." },
        { label: "Save", desc: "Saves all checked rows with filled-in follow-up details and sends notifications." },
        { label: "Reset", desc: "Clears all filters, selections, and form data to start fresh." },
        { label: "Search Bar", desc: "Filter table rows instantly by Enquiry Code, Parent Name, or Mobile number." },
      ],
    },
    {
      icon: <CalendarTodayIcon sx={{ color: "#ad1457", fontSize: 22 }} />,
      title: "Validation Rules",
      color: "#fce4ec",
      borderColor: "#ad1457",
      items: [
        { label: "Required Fields", desc: "For every checked row, Follow Up method, Status, Assigned To, and Follow Up Date are all mandatory before saving." },
        { label: "Date Range", desc: "When using 'Selected Date Wise', both From Date and To Date must be provided." },
        { label: "Notifications", desc: "On successful save, a notification is automatically sent for each processed follow-up." },
      ],
    },
  ];

  return (
    <Container maxWidth={false} sx={{ maxWidth: "1300px", mx: "auto" }}>
      {/* ── AppBar — same as original ── */}
      <AppBar
        position="static"
        sx={{ backgroundColor: "#0B1F3D", boxShadow: "0 2px 8px rgba(0,0,0,0.3)" }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: "0.5px", color: "#ffffff" }}>
              Enquiry Follow-Ups
            </Typography>
            <Tooltip title="View page information & guide" arrow placement="right">
              <IconButton
                onClick={() => setInfoModalOpen(true)}
                size="small"
                sx={{
                  color: "rgba(255,255,255,0.75)",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  border: "1.5px solid rgba(255,255,255,0.25)",
                  borderRadius: "50%",
                  width: 32, height: 32,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#1976d2", borderColor: "#64B5F6",
                    color: "#ffffff", boxShadow: "0 0 0 3px rgba(100,181,246,0.25)", transform: "scale(1.1)",
                  },
                }}
              >
                <InfoOutlinedIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          </Box>

          {isMaster && (
            <Box sx={{ position: "relative" }}>
              <FormControl size="small" sx={{ width: 220 }}>
                <InputLabel
                  sx={{
                    color: "rgba(255,255,255,0.6)", fontSize: "0.75rem", fontWeight: 500,
                    letterSpacing: "0.6px", textTransform: "uppercase", top: "-2px",
                    "&.Mui-focused": { color: "#64B5F6" },
                    "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
                  }}
                >
                  Branch
                </InputLabel>
                <Select
                  value={selectedBranchId || ""}
                  onChange={(e) => setSelectedBranchId(e.target.value)}
                  label="Branch"
                  startAdornment={
                    <InputAdornment position="start">
                      <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
                    </InputAdornment>
                  }
                  sx={{
                    color: "#ffffff", fontWeight: 500, fontSize: "0.875rem",
                    backgroundColor: "rgba(255,255,255,0.07)", backdropFilter: "blur(8px)", borderRadius: "8px",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.15)" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.35)" },
                    "&.Mui-focused": {
                      backgroundColor: "rgba(255,255,255,0.1)",
                      boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
                      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#64B5F6", borderWidth: "1.5px" },
                    },
                    "& .MuiSelect-icon": { color: "rgba(255,255,255,0.5)" },
                    "& .MuiSelect-select": { py: 1.1 },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        mt: 0.5, borderRadius: "10px",
                        border: "1px solid rgba(11,31,61,0.12)",
                        boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
                        "& .MuiList-root": { py: 0.5 },
                      },
                    },
                  }}
                >
                  {branches.map((b) => (
                    <MenuItem key={b.branchId} value={b.branchId}
                      sx={{
                        fontSize: "0.875rem", fontWeight: 500, color: "#0B1F3D",
                        px: 2, py: 1.1, mx: 0.5, borderRadius: "6px",
                        "&:hover": { backgroundColor: "rgba(11,31,61,0.07)" },
                        "&.Mui-selected": { backgroundColor: "rgba(25,118,210,0.1)", color: "#1565C0", fontWeight: 600 },
                      }}
                    >
                      {b.branchName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      {/* ── Main Paper — same as original ── */}
      <Paper elevation={3} style={{ padding: "20px", margin: "6px auto", maxWidth: "100%" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel id="follow-up-type-label">Follow Up Type</InputLabel>
              <Select
                labelId="follow-up-type-label"
                value={followUpType}
                onChange={handleFollowUpTypeChange}
                label="Follow Up Type"
              >
                <MenuItem value="">Select Follow Up Type</MenuItem>
                <MenuItem value="SelectDate">Selected Date Wise</MenuItem>
                <MenuItem value="AllCurrentDate">Current Date</MenuItem>
                <MenuItem value="PendingFollowUp">Pending</MenuItem>
              </Select>
            </FormControl>

            {showDateFields && (
              <>
                <TextField
                  label="From Date" type="date" value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  InputLabelProps={{ shrink: true }} sx={{ maxWidth: 200 }}
                />
                <TextField
                  label="To Date" type="date" value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  InputLabelProps={{ shrink: true }} sx={{ maxWidth: 200 }}
                />
              </>
            )}
          </Box>

          {showDateFields && (
            <Button variant="contained" color="primary" onClick={handleSearch}
              style={{ width: "100px", height: "50px", padding: "10px 0", fontWeight: "bold" }}
            >
              Search
            </Button>
          )}
        </Box>

        {error && (
          <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
        )}

        {loading && (
          <Typography variant="body1" sx={{ mt: 2 }}>Loading...</Typography>
        )}

        {!loading && enquiryData.length > 0 && (
          <Paper sx={{ p: 2, mt: 2, boxShadow: 3 }}>
            <Box sx={{ mb: 2 }}>
              <TextField
                label="Search"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton><SearchIcon /></IconButton>
                    </InputAdornment>
                  ),
                }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                sx={{ maxWidth: 300 }}
              />
            </Box>

            <TableContainer component={Paper} style={{ marginTop: "16px", overflowX: "auto" }}>
              <Table
                sx={{
                  minWidth: 650,
                  border: "1px solid #e0e0e0",
                  "& .MuiTableCell-root": {
                    borderRight: "1px solid #e0e0e0",
                    fontSize: "0.875rem",
                    padding: "8px 12px",
                  },
                  "& .MuiTableHead-root .MuiTableCell-root": {
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    fontSize: "0.875rem",
                    padding: "12px 12px",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "40px", textAlign: "center" }}>
                      <input type="checkbox" checked={selectAll} onChange={handleSelectAllChange} />
                    </TableCell>
                    <TableCell sx={{ width: "110px" }}>Enquiry Code</TableCell>
                    <TableCell sx={{ width: "150px" }}>Parent Name</TableCell>
                    <TableCell sx={{ width: "110px" }}>Mobile</TableCell>
                    <TableCell sx={{ width: "110px" }}>Enquiry Date</TableCell>
                    <TableCell sx={{ width: "120px" }}>Last Follow-Up</TableCell>
                    <TableCell sx={{ width: "140px" }}>Assigned To</TableCell>
                    <TableCell sx={{ width: "200px" }}>Remarks</TableCell>
                    <TableCell sx={{ width: "80px", textAlign: "center" }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.map((enquiry, index) => {
                    const globalIndex = (page - 1) * rowsPerPage + index;
                    const hasError = enquiry.isChecked && (
                      formErrors[`trackedThrough-${globalIndex}`] ||
                      formErrors[`status-${globalIndex}`] ||
                      formErrors[`assignedTo-${globalIndex}`] ||
                      formErrors[`nextFollowUpDate-${globalIndex}`]
                    );
                    // Resolve assigned name from the lookup map
                    const assignedName = enquiry.assignedTo || assignedToMap[enquiry.assignedUserId] || null;

                    return (
                      <TableRow
                        key={globalIndex}
                        sx={{
                          backgroundColor: hasError ? "#fff8f8" : "inherit",
                          "&:hover": { backgroundColor: hasError ? "#fff0f0" : "#fafafa" },
                        }}
                      >
                        <TableCell sx={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={enquiry.isChecked || false}
                            onChange={(e) => handleCheckboxChange(e, globalIndex)}
                          />
                        </TableCell>

                        <TableCell>{enquiry.enquiryCode || "N/A"}</TableCell>
                        <TableCell>{enquiry.parent_GaurdianName || "N/A"}</TableCell>
                        <TableCell>{enquiry.mobile || "N/A"}</TableCell>
                        <TableCell>{enquiry.enquiryDate || "N/A"}</TableCell>

                        {/* Last Follow-Up Date from backend */}
                        <TableCell>
                          {enquiry.enquiryFollowUpDate ? (
                            <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                              {enquiry.enquiryFollowUpDate}
                            </Typography>
                          ) : (
                            <Typography variant="body2" sx={{ color: "#bdbdbd", fontSize: "0.8rem", fontStyle: "italic" }}>
                              —
                            </Typography>
                          )}
                        </TableCell>

                        {/* Assigned To — resolved from userId map */}
                        <TableCell>
                          {assignedName ? (
                            <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                              {assignedName}
                            </Typography>
                          ) : (
                            <Typography variant="body2" sx={{ color: "#bdbdbd", fontSize: "0.8rem", fontStyle: "italic" }}>
                              —
                            </Typography>
                          )}
                        </TableCell>

                        {/* Remarks — truncated with tooltip */}
                        <TableCell>
                          {enquiry.remarks ? (
                            <Tooltip title={enquiry.remarks} placement="top" arrow>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: "0.875rem",
                                  maxWidth: 180,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  cursor: "default",
                                }}
                              >
                                {enquiry.remarks}
                              </Typography>
                            </Tooltip>
                          ) : (
                            <Typography variant="body2" sx={{ color: "#bdbdbd", fontSize: "0.8rem", fontStyle: "italic" }}>
                              —
                            </Typography>
                          )}
                        </TableCell>

                        {/* Actions */}
                        <TableCell sx={{ textAlign: "center" }}>
                          <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
                            <Tooltip title="View follow-up history" arrow>
                              <IconButton
                                size="small"
                                onClick={() => handleEyeClick(enquiry.enquiryId)}
                                sx={{ color: "#1976d2", "&:hover": { backgroundColor: "#e3f2fd" } }}
                              >
                                <FaEye size={15} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit follow-up details" arrow>
                              <IconButton
                                size="small"
                                onClick={() => handleEditClick(globalIndex)}
                                sx={{ color: "#388e3c", "&:hover": { backgroundColor: "#e8f5e9" } }}
                              >
                                <EditIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
              <FormControl sx={{ minWidth: 120 }}>
                <InputLabel>Rows per page</InputLabel>
                <Select
                  value={rowsPerPage}
                  onChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(1); }}
                  label="Rows per page"
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <Pagination
                count={Math.ceil(filteredData.length / rowsPerPage)}
                page={page}
                onChange={(_, p) => setPage(p)}
                color="primary"
              />
            </Box>
          </Paper>
        )}

        {!loading && isSearchPerformed && enquiryData.length === 0 && (
          <Typography variant="body1" sx={{ mt: 2 }}>
            No enquiries found for the selected criteria.
          </Typography>
        )}

        <Box sx={{ mt: 3 }}>
          <Button variant="contained" color="primary" onClick={handleSave} sx={{ mr: 2 }}>
            Save
          </Button>
          <Button variant="outlined" color="primary" onClick={handleReset}>
            Reset
          </Button>
        </Box>
      </Paper>

      {/* ─── Edit Follow-Up Modal — same structure as original ─────────── */}
      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Box
          sx={{
            position: "absolute", top: "50%", left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", sm: 480 },
            bgcolor: "background.paper",
            borderRadius: 2, boxShadow: 24, overflow: "hidden",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#0B1F40", padding: "12px 16px",
              display: "flex", justifyContent: "space-between", alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <EditIcon sx={{ color: "#64B5F6", fontSize: 20 }} />
              <Typography variant="h6" sx={{ color: "#fff", fontWeight: 600 }}>
                Follow-Up Details
              </Typography>
            </Box>
            <IconButton onClick={() => setEditModalOpen(false)} sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" } }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {editingIndex !== null && enquiryData[editingIndex] && (
            <>
              <Box sx={{ backgroundColor: "#f0f4ff", px: 2.5, py: 1.5, borderBottom: "1px solid #e0e0e0" }}>
                <Typography variant="body2" sx={{ color: "#1a237e", fontWeight: 600 }}>
                  {enquiryData[editingIndex].enquiryCode} &nbsp;·&nbsp; {enquiryData[editingIndex].parent_GaurdianName}
                </Typography>
                <Typography variant="caption" sx={{ color: "#5c6bc0" }}>
                  {enquiryData[editingIndex].mobile}
                </Typography>
              </Box>

              <Box sx={{ p: 2.5, display: "flex", flexDirection: "column", gap: 2.5 }}>
               <TextField
  label="Follow Up Date" type="date" value={editForm.nextFollowUpDate}
  onChange={(e) => handleEditFormChange("nextFollowUpDate", e.target.value)}
  InputLabelProps={{ shrink: true }} fullWidth size="small" required
  error={!!editFormErrors.nextFollowUpDate}
  helperText={editFormErrors.nextFollowUpDate || ""}
  inputProps={{ min: new Date().toISOString().split("T")[0] }}
/>

                <FormControl fullWidth size="small" error={!!editFormErrors.trackedThrough} required>
                  <InputLabel>Follow Up Method</InputLabel>
                  <Select
                    value={editForm.trackedThrough}
                    onChange={(e) => handleEditFormChange("trackedThrough", e.target.value)}
                    label="Follow Up Method"
                  >
                    <MenuItem value="">--Select--</MenuItem>
                    <MenuItem value="phone">Phone</MenuItem>
                    <MenuItem value="email">Email</MenuItem>
                  </Select>
                  {editFormErrors.trackedThrough && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {editFormErrors.trackedThrough}
                    </Typography>
                  )}
                </FormControl>

                <FormControl fullWidth size="small" error={!!editFormErrors.status} required>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={editForm.status}
                    onChange={(e) => handleEditFormChange("status", e.target.value)}
                    label="Status"
                  >
                    <MenuItem value="">Select Status</MenuItem>
                    {statusOptions.map((s) => (
                      <MenuItem key={s} value={s}>
                        {s === "Super Hot" ? "Interested" : s}
                      </MenuItem>
                    ))}
                  </Select>
                  {editFormErrors.status && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {editFormErrors.status}
                    </Typography>
                  )}
                </FormControl>

                <FormControl fullWidth size="small" error={!!editFormErrors.assignedTo} required>
                  <InputLabel>Assigned To</InputLabel>
                  <Select
                    value={editForm.assignedTo}
                    onChange={(e) => handleEditFormChange("assignedTo", e.target.value)}
                    label="Assigned To"
                  >
                    <MenuItem value="">--Select--</MenuItem>
                    {assignedToOptions.map((opt) => (
                      <MenuItem key={opt.userId} value={opt.employeeName}>
                        {opt.employeeName}
                      </MenuItem>
                    ))}
                  </Select>
                  {editFormErrors.assignedTo && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {editFormErrors.assignedTo}
                    </Typography>
                  )}
                </FormControl>

                <TextField
                  label="Remarks" value={editForm.remarks}
                  onChange={(e) => handleEditFormChange("remarks", e.target.value)}
                  placeholder="Enter any remarks or notes..."
                  fullWidth size="small" multiline rows={3}
                  inputProps={{ maxLength: 500 }}
                  helperText={`${editForm.remarks.length}/500`}
                  FormHelperTextProps={{ sx: { textAlign: "right", mr: 0 } }}
                />
              </Box>
            </>
          )}

          <Box
            sx={{
              px: 2.5, py: 1.5, borderTop: "1px solid #e0e0e0",
              display: "flex", justifyContent: "flex-end", gap: 1.5, backgroundColor: "#fafafa",
            }}
          >
            <Button onClick={() => setEditModalOpen(false)} variant="outlined" color="inherit" sx={{ fontWeight: 600 }}>
              Cancel
            </Button>
            <Button onClick={handleEditSave} variant="contained" color="primary" sx={{ fontWeight: 600, px: 3 }}>
              Apply
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* ─── View History Modal — fixed remarks bug ──────────────────────── */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute", top: "50%", left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400, bgcolor: "background.paper",
            borderRadius: 2, boxShadow: 24, overflow: "hidden",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#0B1F40", padding: "12px 16px",
              display: "flex", justifyContent: "space-between", alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ color: "#fff" }}>Enquiry Details</Typography>
            <IconButton onClick={() => setModalOpen(false)} sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" } }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ maxHeight: "400px", overflowY: "auto", padding: "16px" }}>
            {selectedEnquiry && selectedEnquiry.length > 0 ? (
              selectedEnquiry.map((enquiry, index) => (
                <Box key={index} sx={{ marginBottom: "16px" }}>
                  {selectedEnquiry.length > 1 && (
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: "bold", marginBottom: "8px", color: "#1976d2", borderBottom: "1px solid #e0e0e0", paddingBottom: "4px" }}
                    >
                      Follow-up {index + 1} of {selectedEnquiry.length}
                    </Typography>
                  )}
                  <TableContainer sx={{ marginBottom: "16px" }}>
                    <Table size="small">
                      <TableBody>
                        {index === 0 && (
                          <>
                            <TableRow>
                              <TableCell sx={{ fontWeight: "bold", width: "40%" }}>Enquiry Code:</TableCell>
                              <TableCell>{enquiry.enquiryCode}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontWeight: "bold" }}>Parent/Guardian Name:</TableCell>
                              <TableCell>{enquiry.parent_GaurdianName}</TableCell>
                            </TableRow>
                          </>
                        )}
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>Follow Up Date:</TableCell>
                          <TableCell>{enquiry.enquiryFollowUpDate}</TableCell>
                        </TableRow>
                        {/* ✅ FIXED: was incorrectly using enquiry.status for Remarks */}
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>Remarks:</TableCell>
                          <TableCell sx={{ wordBreak: "break-word" }}>
                            {enquiry.remarks || <span style={{ color: "#bdbdbd", fontStyle: "italic" }}>No remarks</span>}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>Status:</TableCell>
                          <TableCell>
                            {enquiry.status ? (
                              <Chip
                                label={STATUS_CONFIG[enquiry.status]?.label || enquiry.status}
                                size="small"
                                sx={{
                                  fontSize: "0.75rem", height: 22,
                                  backgroundColor: STATUS_CONFIG[enquiry.status]?.bg || "#f5f5f5",
                                  color: STATUS_CONFIG[enquiry.status]?.color || "#616161",
                                }}
                              />
                            ) : (
                              <span style={{ color: "#bdbdbd", fontStyle: "italic", fontSize: "0.8rem" }}>—</span>
                            )}
                          </TableCell>
                        </TableRow>
                       <TableRow>
  <TableCell sx={{ fontWeight: "bold" }}>Followed by:</TableCell>
  <TableCell>{enquiry.followedByEmployeeName || enquiry.followedByUserName || "N/A"}</TableCell>
</TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ))
            ) : (
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={2} sx={{ textAlign: "center" }}>No data found</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>

          <Box sx={{ padding: "16px", borderTop: "1px solid #e0e0e0", textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            <Button onClick={() => setModalOpen(false)} variant="contained" color="primary">OK</Button>
          </Box>
        </Box>
      </Modal>

      {/* ─── Info Modal — same as original ──────────────────────────────── */}
      <Modal open={infoModalOpen} onClose={() => setInfoModalOpen(false)}>
        <Box
          sx={{
            position: "absolute", top: "50%", left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", sm: 620, md: 700 },
            maxHeight: "85vh", bgcolor: "background.paper",
            borderRadius: 3, boxShadow: "0 24px 64px rgba(11,31,61,0.22)",
            overflow: "hidden", display: "flex", flexDirection: "column",
          }}
        >
          <Box
            sx={{
              background: "linear-gradient(135deg, #0B1F40 0%, #1565C0 100%)",
              padding: "16px 20px",
              display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box sx={{ backgroundColor: "rgba(255,255,255,0.15)", borderRadius: "50%", width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <InfoOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
              </Box>
              <Box>
                <Typography variant="h6" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.2 }}>
                  Enquiry Follow-Ups — Guide
                </Typography>
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.65)" }}>
                  Complete reference for all features and fields
                </Typography>
              </Box>
            </Box>
            <IconButton onClick={() => setInfoModalOpen(false)} sx={{ color: "rgba(255,255,255,0.7)" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ overflowY: "auto", p: 2.5, display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ backgroundColor: "#f0f4ff", border: "1px solid #c5d3f0", borderRadius: 2, p: 2 }}>
              <Typography variant="body2" sx={{ color: "#1a237e", lineHeight: 1.7 }}>
                The <strong>Enquiry Follow-Ups</strong> page allows staff to track, manage, and record follow-up actions on active enquiries.
                Use the filter to load records, click the <strong>Edit</strong> icon on any row to fill in follow-up details, then save — all from a single screen.
                The <strong>Assigned To</strong> column is resolved automatically from the backend.
              </Typography>
            </Box>

            {infoSections.map((section, sIdx) => (
              <Box
                key={sIdx}
                sx={{
                  backgroundColor: section.color,
                  border: `1px solid ${section.borderColor}30`,
                  borderLeft: `4px solid ${section.borderColor}`,
                  borderRadius: 2, p: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                  {section.icon}
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1a1a2e", fontSize: "0.95rem" }}>
                    {section.title}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
                  {section.items.map((item, iIdx) => (
                    <Box key={iIdx} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                      <Chip
                        label={item.label}
                        size="small"
                        sx={{
                          fontSize: "0.7rem", fontWeight: 600, height: 22, flexShrink: 0,
                          backgroundColor: `${section.borderColor}18`,
                          color: section.borderColor,
                          border: `1px solid ${section.borderColor}40`,
                          mt: "1px",
                        }}
                      />
                      <Typography variant="body2" sx={{ color: "#424242", lineHeight: 1.5, fontSize: "0.82rem" }}>
                        {item.desc}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}

            <Box sx={{ backgroundColor: "#fffde7", border: "1px solid #f9a825", borderRadius: 2, p: 2, display: "flex", gap: 1.5, alignItems: "flex-start" }}>
              <Typography sx={{ fontSize: "1.1rem", mt: "1px" }}>💡</Typography>
              <Typography variant="body2" sx={{ color: "#5d4037", lineHeight: 1.65, fontSize: "0.82rem" }}>
                <strong>Pro Tip:</strong> Click the green <strong>Edit</strong> icon on any row to fill in follow-up details via the modal.
                The <em>Assigned To</em> field is pre-filled from the backend automatically.
                Editing a row auto-checks it for saving. Use <em>Select All</em> to bulk-select edited rows, then hit <strong>Save</strong>.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ borderTop: "1px solid #e0e0e0", px: 2.5, py: 1.5, display: "flex", justifyContent: "flex-end", flexShrink: 0, backgroundColor: "#fafafa" }}>
            <Button onClick={() => setInfoModalOpen(false)} variant="contained" color="primary" sx={{ fontWeight: 600, px: 3 }}>
              Got It
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default EnquiryFollow;